export default "__VITE_ASSET__BnsZg8vJ__"